<template>
    <div class="ppv2-min-h-screen ppv2-bg-white dark:ppv2-bg-dark">
        <div class="ppv2-p-6">
            <ConfigurationHeader
                :page="page"
                :title="title"
                :subtitle="subtitle"
                :description="description"
                :info-message="infoMessage"
                :progress-percentage="progressPercentage"
                @back-action="handleBackAction"
            />
            <component :is="currentComponent" ref="currentView" @card-action="handleCardAction" />
        </div>
    </div>
</template>

<script>
import ConfigurationHeader from '../../Shared/ConfigurationHeader.vue'
import ConfigurationCard from '../../Shared/ConfigurationCard.vue'
import ResourcePlanning from './ResourcePlanning.vue'
import Info from './EstablishmentInfo/Info.vue'
import Default from './Default.vue'

export default {
    name: 'EstablishmentIndex',
    components: {
        ConfigurationHeader,
        ConfigurationCard,
        Default,
        Info,
        ResourcePlanning,
    },
    data() {
        return {
            title: this.$t('configuration.title'),
            subtitle: this.$t('configuration.subtitle'),
            description: this.$t('configuration.description'),
            infoMessage: '' /* this.$t('configuration.infoMessage'), */,
            progressPercentage: 45,
            page: null, // control active page
        }
    },

    computed: {
        currentComponent() {
            if (this.page === 'Info') return 'Info'
            if (this.page === 'ResourcePlanning') return 'ResourcePlanning'
            return 'Default'
        },
    },

    methods: {
        handleCardAction(card) {
            if (card.title === this.$t('configuration.cards.schedule.title')) {
                this.page = 'ResourcePlanning'
            } else {
                this.page = null
            }
        },

        handleBackAction(data) {
            const view = this.$refs.currentView
            if (this.page === 'ResourcePlanning' && view && view.currentSubSection) {
                view.handleBackToLanding()
                return
            }
            this.page = 'Default'
        },
    },
}
</script>
<style scoped>
.bgGray {
    background-color: #f3f4f6;
}

.dark .bgGray {
    background-color: #060b28;
}

.dark .ppv2-bg-white {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
